import BarcodeOutlineIcon from '@assets/icons/barcode-outline.svg';
import i18n from '@/utils/i18n';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

export const PreScanComponent: React.FC<{}> = () => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.resultsContainer}>
      <View style={styles.emptyState}>
        <BarcodeOutlineIcon stroke={theme.sk.color.icon.secondary} />
        <Text style={[TYPOGRAPHY.medium, styles.externalEmptyStateText]}>
          {i18n.t('external_scanner.empty_state')}
        </Text>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  emptyState: {
    alignItems: 'center',
    flex: 1,
    gap: 12,
    paddingTop: 48,
  },
  externalEmptyStateText: {
    color: theme.sk.color.text.secondary,
  },
  resultsContainer: {
    alignItems: 'center',
    flex: 1,
    marginTop: 24,
    paddingLeft: theme.sk.spacing.spaceLarge,
    paddingRight: theme.sk.spacing.spaceLarge,
    paddingTop: 24,
  },
}));
